var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeoblockSuccess({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3707_20916)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_3707_20916)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120 55.0001C120 65.8781 116.775 76.5116 110.731 85.5563C104.688 94.6011 96.0977 101.651 86.0477 105.813C75.9978 109.976 64.9391 111.065 54.2702 108.943C43.6012 106.821 33.801 101.583 26.1091 93.8909C18.4172 86.199 13.179 76.3989 11.0569 65.7299C8.93466 55.0609 10.0238 44.0024 14.1866 33.9524C18.3494 23.9025 25.3989 15.3127 34.4437 9.26918C43.4884 3.22569 54.1221 0 65.0001 0C79.5871 0 93.5766 5.79443 103.891 16.1089C114.206 26.4235 120 40.4132 120 55.0001Z",
    fill: "url(#paint0_linear_3707_20916)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M62.0131 76.1707H61.832L60.5939 75.3485C55.3984 71.8305 50.7856 67.5611 46.9151 62.6882L45.9488 61.4838C41.8633 56.2684 39.5517 49.9436 39.3359 43.3899V42.5673C39.5549 36.0809 42.3526 29.93 47.14 25.4099C51.9274 20.8899 58.331 18.3533 65.0025 18.334H65.848C72.5314 18.5704 78.8582 21.3259 83.4905 26.0184C88.1227 30.7109 90.6971 36.9721 90.6691 43.4777V43.7717C90.5182 51.5264 86.6229 59.5451 79.4362 66.9473C76.0355 70.3888 72.2355 73.4349 68.1127 76.024H67.9617C67.0899 76.6581 66.0307 77.0008 64.9421 77.0008C63.8536 77.0008 62.7943 76.6581 61.9225 76.024L62.0131 76.1707ZM64.3382 22.8283C58.8535 23.0036 53.6539 25.2469 49.8389 29.0842C46.0239 32.9214 43.8926 38.0516 43.8955 43.3899V44.4473C44.2908 49.6967 46.2533 54.7194 49.5422 58.8989C53.6248 64.2092 58.6326 68.7826 64.3382 72.4111L64.5798 72.5872C64.6795 72.6739 64.8084 72.722 64.9421 72.722C65.0758 72.722 65.2048 72.6739 65.3045 72.5872L65.546 72.3817C69.381 69.976 72.9173 67.1472 76.0845 63.9515C81.8356 58.664 85.383 51.5007 86.0492 43.8302V42.8316C85.8842 37.4859 83.5847 32.413 79.6384 28.6894C75.6922 24.9657 70.4097 22.8843 64.912 22.8867L64.3382 22.8283ZM55.2794 43.7423C55.2854 41.8613 55.8642 40.024 56.9429 38.4628C58.0215 36.9016 59.5516 35.6862 61.3398 34.9704C63.128 34.2545 65.0942 34.0702 66.99 34.4408C68.8858 34.8113 70.6263 35.7201 71.9915 37.0522C73.3567 38.3844 74.2855 40.0802 74.6606 41.9255C75.0357 43.7708 74.8401 45.6832 74.0988 47.4205C73.3574 49.1578 72.1034 50.6423 70.4952 51.6867C68.887 52.7312 66.9966 53.2888 65.0629 53.2888C63.7719 53.2966 62.4922 53.0547 61.2979 52.5778C60.1036 52.1008 59.0186 51.3979 58.1057 50.5099C57.1928 49.6219 56.4703 48.5665 55.9799 47.4047C55.4896 46.243 55.2412 44.9982 55.2492 43.7423H55.2794ZM59.839 43.7423C59.839 44.7474 60.1454 45.7296 60.7194 46.5653C61.2934 47.401 62.1093 48.0524 63.0638 48.437C64.0184 48.8217 65.0687 48.9221 66.082 48.726C67.0954 48.53 68.0262 48.0462 68.7568 47.3355C69.4873 46.6248 69.9849 45.7192 70.1864 44.7334C70.388 43.7477 70.2846 42.726 69.8892 41.7975C69.4938 40.8689 68.8242 40.0754 67.9651 39.517C67.1061 38.9586 66.0961 38.6604 65.0629 38.6604C64.3732 38.6526 63.6889 38.7785 63.0498 39.0308C62.4107 39.283 61.8296 39.6567 61.3405 40.1298C60.8514 40.6028 60.4641 41.1658 60.2011 41.786C59.9381 42.4062 59.8048 43.0714 59.8088 43.7423H59.839Z",
    fill: "url(#paint1_linear_3707_20916)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.189 91.1062L70.5365 91.2587L70.493 91.2805C71.1229 91.5327 71.9191 91.6568 72.7235 91.6286C73.5279 91.6004 74.2817 91.4217 74.8353 91.128C75.4452 90.8221 75.7879 90.4076 75.7879 89.9752C75.7879 89.5428 75.4452 89.1281 74.8353 88.8221L69.6245 86.2114L74.8353 83.6009L75.1828 83.4052C75.7586 83.0763 76.05 82.6462 75.993 82.2096C75.936 81.7731 75.5352 81.3658 74.8788 81.0773C74.2224 80.7888 73.364 80.6429 72.4927 80.6715C71.6213 80.7001 70.8083 80.9008 70.2325 81.2297L65.0216 83.8402L59.8108 81.2297L59.4636 81.0773C58.8337 80.8251 58.0374 80.7009 57.233 80.7291C56.4286 80.7573 55.6749 80.936 55.1212 81.2297C54.5114 81.5356 54.1687 81.9501 54.1687 82.3825C54.1687 82.8149 54.5114 83.2297 55.1212 83.5356L60.3321 86.1463L55.1212 88.7568L54.8172 88.9308C54.5321 89.0936 54.3138 89.2831 54.1748 89.4882C54.0358 89.6933 53.9788 89.9102 54.007 90.1263C54.0353 90.3425 54.1479 90.5537 54.3391 90.748C54.5303 90.9423 54.7962 91.1158 55.1212 91.2587C55.4463 91.4015 55.8242 91.5109 56.2336 91.5805C56.643 91.6502 57.0759 91.6786 57.5073 91.6645C57.9388 91.6503 58.3604 91.5937 58.7482 91.498C59.136 91.4022 59.4824 91.2691 59.7676 91.1062L64.9782 88.4958L70.189 91.1062Z",
    fill: "url(#paint2_linear_3707_20916)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3707_20916",
    x: 0,
    y: 0,
    width: 130,
    height: 130,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.305882 0 0 0 0 0.67451 0 0 0 0 0.976471 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3707_20916"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3707_20916",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_3707_20916",
    x: 10,
    y: 0,
    width: 110,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.279167 0 0 0 0 0.655653 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3707_20916"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3707_20916",
    x1: 1.72411,
    y1: -112.2,
    x2: 144.26,
    y2: -104.852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2894FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3707_20916",
    x1: 65.0027,
    y1: 77.0008,
    x2: 65.0027,
    y2: 18.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5028,
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3707_20916",
    x1: 65,
    y1: 91.668,
    x2: 65,
    y2: 80.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5028,
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeoblockSuccess);
export default __webpack_public_path__ + "static/media/geoblock-success.813c2db687ae7ebe37e3a9045416f0f9.svg";
export { ForwardRef as ReactComponent };